import Vue from 'vue';
import Vuex from 'vuex';
import { isNil, isEqual } from 'lodash';
import AuthService from "@/service/AuthService";
import ApiService from "@/service/ApiService";

Vue.use(Vuex);

//export const serviceUrl = "http://localhost:8081"; //USER_SERVICE_URL
export const serviceUrl = "https://heroku-adminservice.herokuapp.com";

const AdminStore = {
    state: {
        admin: {
            id: '',
            name: '',
            isPermaAdmin: {
                type: Boolean
            }
        },
        adminList: [],
    },
    getters: {
        admin: state => state.admin,
        adminName: state => state.admin.name,
        //adminList: state => state.adminList,
        isAuthenticated: state => (!isEqual(state.admin.name, '')
                && !isNil(localStorage.getItem('admin'))),
        isSuperAdmin: state => state.admin.isPermaAdmin,

    },
    mutations: {
        updateAdmin(state, admin) {
            state.admin = admin;
        },
        updateAdminList(state, adminList) {
            state.adminList = adminList;
        },
    },
    actions: {
        async login({ dispatch, getters }, { name, password }) {
            if (!getters.isAuthenticated) {
                const success = await AuthService.login(name, password);
                if (success) {
                    dispatch('fetchAdmin');
                    // if (dispatch('fetchUser')) {
                    //   dispatch('fetchUserList');
                    // }
                    return true;
                }
            }
            console.log('Failed to login!');
            return false;
        },
        async fetchAdmin({ commit }) {
            const adminInfo = await ApiService.doGet(`${serviceUrl}/admins/me`); //users/me OLD
            console.log("Admin Info: ", adminInfo);

            if (!isNil(adminInfo)) {
                commit('updateAdmin', adminInfo);
                console.log('Successfully fetched admin information');
                return true;
            }
            return false;
        },
        async fetchAdminList({ commit }) {
            const rawAdminList = await ApiService.doGet(`${serviceUrl}/admins`);
            let adminList;
            if (!isNil(rawAdminList)) {
                commit('updateAdminList', adminList);
                return true;
            }
            return false;
        },
        async registerAdmin({ getters }, { name, displayName, password, isPermaAdmin, authorDescription, authorImage }) {

            if (getters.isAuthenticated) {

                if (!isNil(name) && (!isNil(displayName)) &&!isNil(password) && !isNil(isPermaAdmin)
                && (!isNil(authorDescription)) && !isNil(authorImage)) {
                    console.log('im there');
                    const response = await ApiService.doPost(`${serviceUrl}/admins/create`,
                        { name: name, displayName, password, isPermaAdmin, authorDescription, authorImage });

                    if (!isNil(response)) {
                        return response;
                    }
                }
            }
            return null;
        },
        async updateAdmin({ commit, state }, { id, password, newPassword }) {
            const newAdminInformation = {
                id,
                password,
                newPassword,
            };

            console.log("Admin State: ", state.admin);

            const updatedAdmin = await ApiService.doPost(`${serviceUrl}/admins/${id}/update`, newAdminInformation); //USER_SERVICE_URL to /users/id/update
            if (!isNil(updatedAdmin)) {
                if (updatedAdmin.id === state.admin.id) {
                    commit('updateAdmin', updatedAdmin);
                }
                console.log('Successfully updated admin information.');

                return updatedAdmin;
            }
            return null;
        },
        logout({ dispatch }) {
            AuthService.logout();
            dispatch('clearStore');
            console.log('Logged out');
        },
        clearStore({ commit }) {
            const emptyStore = {
                admin: {
                    id: '',
                    name: '',
                    isPermaAdmin: ''
                },
            };
            commit('updateAdmin', emptyStore.admin);
        },

        async deleteAdmin({ dispatch }, id) {
            const response = await ApiService.doPost(`${serviceUrl}/admins/${id}/delete`);
            if (!isNil(response)) {
                dispatch('fetchAdminsList');
                return response;
            }
            return null;
        },
    },
};

export default AdminStore;
